import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { UseMutationProps } from "@lib/types/Api";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { Product } from "@lib/types/Billing";
import CoinPriceTextFormat from "@lib/components/MiniComponents/Others/CoinPriceTextFormat";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { TableColumnsProps } from "@lib/types/General";

type Props<T> = TableColumnsProps<T> & {
  openModal: boolean;
  handleSelectItem: (manager: T) => void;
  deleteQuery: UseMutationProps<T>;
};

const getColumns = <T extends Product>(props: Props<T>): ColumnsType<T> => {
  const { deleteQuery, handleSelectItem } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (v, r) => (
        <TableIdButton
          // link={`/payment_history/list/${r.id}`}
          text={`#${shortenString(r.id)}`}
          textToBeCopied={r.id}
        />
      ),
      width: "180px",
      filterType: "search",
    },
    {
      title: "common.productName",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: "300px",
      filterType: "search",
    },
    {
      title: "common.description",
      dataIndex: "description",
      key: "description",
      width: "300px",
      filterType: "search",
    },
    {
      title: "common.amount",
      dataIndex: "unitPrice",
      width: "140px",
      align: "right",
      render: (value, r) => (
        <CoinPriceTextFormat amount={value} showCurrency={r?.currency} />
      ),
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY"),
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      key: "createdBy",
      width: "150px",
      filterType: "dropdown",
    },
    {
      title: "common.updatedAt",
      dataIndex: "updatedAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY"),
    },
    {
      title: "common.updatedBy",
      dataIndex: "updatedBy",
      width: "160px",
      filterType: "dropdown",
    },

    {
      title: "common.actions",
      dataIndex: "actions",
      key: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "100px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="edit"
            onClick={() => handleSelectItem(record)}
            noLabel
          />

          <ActionButton
            type="delete"
            onClick={() => deleteQuery.mutate(record)}
            itemName="common.product"
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
